import { syntheticEntryQuery } from '../../shared/content-media/content-media';
import { useSynLive } from '../../shared/product-review/session/ProductReviewSession';
/** Only existing scoped read APIs supply figures. Missing aggregate APIs never become fixtures. */
export function VendorWorkbench() {
  const live = useSynLive();
  const base = '/demo/technology-solutions/provider-portal';
  const link = (suffix: string) => base + suffix + syntheticEntryQuery();
  const vendorCards = [
    ['本次会话访问产品', live.auth ? live.knownIds.length : '—', '/products'],
    ['产品资料与文档', '进入', '/documents'],
    ['提交与审核', '查看', '/submissions'],
    ['企业资料', '未接入', '/organization'],
  ];
  return (
    <div className={'provider-home portal-card'}>
      <div className={'provider-welcome'}>
        <div>
          <h1>{'你好，欢迎来到厂商工作台'}</h1>
          <p>
            {live.auth ? `当前账号：${live.auth.account}` : '登录后读取当前账号有权访问的业务数据'}
          </p>
          <small>本地业务服务 · 持久化数据 · 非生产环境</small>
        </div>
      </div>
      {
        <section className="provider-hero" aria-label="消防装备产品示意横幅">
          <img src="/portals/hero.png" alt="消防装备示意图，非业务记录" />
          <div className="provider-hero-shade" />
          <div className="provider-hero-copy">
            <h2>
              创新技术
              <br />
              助力更安全的世界
            </h2>
            <p>专业的消防装备与解决方案提供商</p>
          </div>
        </section>
      }
      <div className={'provider-stats'}>
        {vendorCards.map(([label, count, suffix]) => (
          <a
            key={String(label)}
            className={'provider-stat provider-stat-blue'}
            href={link(String(suffix))}
          >
            <div>
              <span>{label}</span>
              <strong>{count}</strong>
              <small>{'以当前会话及服务读回为准'}</small>
            </div>
          </a>
        ))}
      </div>
      {
        <div className="provider-home-bottom">
          <section className="provider-recent portal-card">
            <h2>本次会话访问的产品</h2>
            <p>后端尚未提供全量产品列表与统计接口；可在“我的产品”按编号读取或创建产品。</p>
            {(live.auth ? live.knownIds : []).map((id) => (
              <a
                className="provider-recent-row"
                key={id}
                href={link('/products/' + encodeURIComponent(id))}
              >
                {id}
              </a>
            ))}
            <a href={link('/products')}>进入我的产品</a>
          </section>
          <section className="provider-reminders portal-card">
            <h2>业务入口</h2>
            <p>产品创建、资料修订、提交、退回后修改均使用已有后端流程。</p>
            <a href={link('/submissions')}>查看提交与审核</a>
          </section>
        </div>
      }
    </div>
  );
}
